import {ErrorHandler, Injectable} from '@angular/core';

import {FileLoadService} from './services/file-load.service';
import {ErrorHandleService} from './services/error-handle.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  constructor(private errorHandleSvc: ErrorHandleService) {}

  handleError(err: Error) {
    this.errorHandleSvc.sendErrorLog(err);
  }
}
